module.exports = __webpack_public_path__ + "static/media/payment-icon1.792c0328.svg";